import { node, oneOfType, arrayOf } from 'prop-types';

const ChildrenPropType = oneOfType([node, arrayOf(node)]);

export default ChildrenPropType;
